import { render, staticRenderFns } from "./DuplicateContactsModal.vue?vue&type=template&id=490d2b70&"
import script from "./DuplicateContactsModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateContactsModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateContactsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports